import { Component, inject, signal } from '@angular/core';
import { ExamTabLockService } from '../../../core/security/exam-tab-lock.service';
import { ImageEnum } from '../../utils/image.enum';
import { PrimaryButtonComponent } from '../primary-button/primary-button';

@Component({
  selector: 'app-duplicate-tab-overlay',
  imports: [PrimaryButtonComponent],
  templateUrl: './duplicate-tab-overlay.html',
})
export class DuplicateTabOverlayComponent {
  private readonly tabLock = inject(ExamTabLockService);

  protected readonly imageEnum = ImageEnum;
  protected readonly isBlocked = this.tabLock.isBlockedByOtherTab;
  protected readonly closeFailed = signal(false);

  protected closeTab(): void {
    // Browsers only let scripts close tabs they opened themselves, so this
    // usually does nothing; the hint below tells the candidate to close it.
    window.close();
    setTimeout(() => this.closeFailed.set(!window.closed), 200);
  }
}
